export const theme = {
  colors: {
    background: {
      backgroundColor: '#424449',
      backgroundColorDarker: '#3b3c41',
      backgroundColorDarkest: '#333539',
    },
    body: {
      bodyColor: '#bdbdbd',
    },
    button: {
      buttonColor: '#8ed6c9',
      buttonColorHover: '#72aba1',
    },
    plans: {
      small: '#82c6ff',
      medium: '#ffd67c',
      large: '#ff9265',
    },
    fonts: {
      fontColor: '#373F49',
    },
  },
  fonts: {
    fontFamily: 'Kollektif, sans-serif',
    fontSize: '18px',
    fontSizeSmall: '14px',
  },
  sizes: {
    navbarHeight: '62px',
    siteBaseWidth: '940px',
    mobile: '850px',
    desktopSmall: '1100px',
  },
}

export const breakpoints = {
  mobile: `(max-width: ${theme.sizes.mobile})`,
  desktopSmall: `(max-width: ${theme.sizes.desktopSmall}) and (min-width: ${theme.sizes.mobile})`,
}
